import { getAttachmentsBulk, getAttachment, createAttachmentRequest, deleteAttachment, getAssetAttachment, getEntityAttachments, getFileAttachmentDropdownValues, getEntityAttachmentsObj, getAttachmentObj, deleteAttachmentObj, getEntityAttachmentsMulti } from "../../../../services/requests";
import { DataSource } from "../data-source";


export const attachmentDataSource = {
  name: 'attachments',
  pk: 'attachmentId',
  additionalRequests: [
    {
      name: 'fetchAssetAttachment',
      request: getAssetAttachment
    },
    {
      name: 'fetchFileAttachmentDropdownValues',
      request: getFileAttachmentDropdownValues,
    },
    {
      name: 'createAttachment',
      request: createAttachmentRequest,
    },
    {
      name: 'fetchEntityAttachments',
      request: getEntityAttachmentsObj,
    },
    {
      name: 'fetchEntityAttachmentsMulti',
      request: getEntityAttachmentsMulti,
    },
    {
      name: 'deleteAttachmentAction',
      request: deleteAttachmentObj,
    },
    {
      name: 'fetchAttachment',
      request: getAttachmentObj
    },
    {
      name: 'fetchAttachmentBulk',
      request: getAttachmentsBulk
    },
  ]
} as DataSource